<template>
  <div>
    <div v-if="cards.length">
      <h5>Добавлено:</h5>
      <div v-for="(c, index) in cards" :key="index" class="mb-2">
        {{ index + 1 }}. {{ c.card_number }}
      </div>
    </div>
    <cards
      :id="order.client.id"
      @inputCard="add"
      v-model="order.card_id"
      :card="order.card"
    />
    <div v-if="card" class="border">
      <h5>Подтверждение</h5>
      <fg-input
        :type="`number`"
        :label="`Введите код из смс, которое пришло клиенту`"
        v-model="code"
      ></fg-input>
      <br />
      <br />
      <button @click="verify" class="btn btn-info w-100">Подтвердить</button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../../plugins/functions";
export default {
  components: {
    Cards: () => import("@/components/Item/Order/Client/Cards"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {
    this.get();
  },
  data() {
    return {
      code: "",
      cards: [],
      card: null,
    };
  },
  methods: {
    async add(data) {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.card = null;
      this.$http({
        url: `${partner["endpoint_url"]}cards/request-attach`,
        method: "POST",
        data: {
          client_id: this.value.id,
          card_number: data.card_number.split(" ").join(""),
          expire: data.exp.replace("/", ""),
        },
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.card = data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async verify() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}cards/attach`,
        method: "POST",
        data: {
          client_id: this.value.id,
          code: this.code,
          card_number: this.card.card_number.split(" ").join(""),
          expire: this.card.exp.replace("/", ""),
        },
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.$emit("update", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async get() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}cards?client_id=${this.value.id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.cards = response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>